module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n        Filter By\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": function($event) {
        return _vm.getBranchWiseRecord(_vm.branch)
      }
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1)])])]), _vm._v(" "), (_vm.canAccess('collection-center-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Collection Center List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [(_vm.canAccess('collection-center-create')) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rows.data), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.centerCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.city))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.status == 'active') ? _c('div', [_c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Active")])]) : _c('div', [_c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("InActive")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group dropup"
    }, [_vm._m(1, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu dropdown-menu-right",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.canAccess('collection-center-view')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.viewModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" View\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('collection-center-update')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Update\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('collection-center-delete')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.deleteModal(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete\n                      ")])]) : _vm._e()])])])])
  }), 0)])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Add New")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Update")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateGroup() : _vm.createGroup()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control input-sm",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select Company Branch\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(bran) {
    return _c('option', {
      key: bran.id,
      domProps: {
        "value": bran.id
      }
    }, [_vm._v("\n                                " + _vm._s(bran.name) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'is-invalid': _vm.form.errors.has('name'),
    },
    attrs: {
      "type": "text",
      "name": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    staticClass: "form-control input-sm",
    class: {
      'is-invalid': _vm.form.errors.has('address'),
    },
    attrs: {
      "type": "text",
      "name": "address",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "address"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.city),
      expression: "form.city"
    }],
    staticClass: "form-control input-sm",
    class: {
      'is-invalid': _vm.form.errors.has('city'),
    },
    attrs: {
      "type": "text",
      "name": "city",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.collectionTime),
      expression: "form.collectionTime"
    }],
    staticClass: "form-control input-sm",
    class: {
      'is-invalid': _vm.form.errors.has(
        'collectionTime'
      ),
    },
    attrs: {
      "type": "text",
      "name": "collectionTime"
    },
    domProps: {
      "value": (_vm.form.collectionTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "collectionTime", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "collectionTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.collectionDay),
      expression: "form.collectionDay"
    }],
    staticClass: "form-control input-sm",
    class: {
      'is-invalid': _vm.form.errors.has(
        'collectionDay'
      ),
    },
    attrs: {
      "name": "collectionDay"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "collectionDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Mon"
    }
  }, [_vm._v("Monday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Tues"
    }
  }, [_vm._v("Tuesday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Wed"
    }
  }, [_vm._v("Wednesday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Thu"
    }
  }, [_vm._v("Thursday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Fri"
    }
  }, [_vm._v("Friday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Sat"
    }
  }, [_vm._v("Saturday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Sun"
    }
  }, [_vm._v("Sunday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EveryDay"
    }
  }, [_vm._v("EveryDay")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "collectionDay"
    }
  })], 1), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "active"
    },
    domProps: {
      "checked": _vm._q(_vm.form.status, "active")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "status", "active")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Active")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "inActive"
    },
    domProps: {
      "checked": _vm._q(_vm.form.status, "inActive")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "status", "inActive")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-remove text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("InActive")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  SAVE GROUP\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  UPDATE GROUP\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                  CANCEL\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("RESET")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('ul', {
    staticClass: "list-group mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Name")]), _vm._v(" "), (_vm.record.branch) ? _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.branch.name))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item",
    staticStyle: {
      "padding-bottom": "28px"
    }
  }, [_c('b', [_vm._v("Address")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right mb-10"
  }, [_vm._v(_vm._s(_vm.record.address))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("City / Village Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.city))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('ul', {
    staticClass: "list-group mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Collection Time")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.collectionTime))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Collection Day")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.collectionDay))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Status")]), _vm._v(" "), (_vm.record.status == 'active') ? _c('a', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")])]) : _c('a', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("InActive")])])])])])])])])]), _vm._v(" "), _vm._m(12)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("Code ")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("City/Village")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-flat btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                    Task "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Group Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Address "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("City / Village Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Collection Time\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Collection Day\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Group Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Collection Center Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CLOSE\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f0727bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/master/company/GroupMaster.vue
// module id = 843
// module chunks = 0